export const Pill = ({ children, singleBorder = false }: { singleBorder?: boolean; children: React.ReactNode }) => {
  if (singleBorder) {
    return (
      <div className="rounded-full bg-linear-to-r from-[#91B5F6]/60 to-[#3266B5]/60 p-px w-fit">
        <div className="h-full w-full flex items-center justify-center rounded-full bg-background-secondary">
          <div className="px-4 py-2 uppercase font-medium text-xs text-text-accent">{children}</div>
        </div>
      </div>
    )
  }

  return (
    <div className="border border-[#91B5F6]/20 bg-black/50 rounded-full shadow-[0px_2px_12px_0px_rgba(106,157,252,0.10)] p-1 w-fit">
      <div className="px-4 py-2 rounded-full border border-[#91B5F6]/50 bg-black/50">
        <div className="uppercase font-medium text-xs text-text-accent">{children}</div>
      </div>
    </div>
  )
}
